import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { money } from "@/lib/api";

const COLORS = ["#10B981", "#D97706", "#3B82F6"];

export default function AllocationChart({ p }) {
  const data = [
    { name: "Stocks", value: p.stocks_value },
    { name: "Real estate", value: p.property_value },
    { name: "Cash", value: p.cash_balance },
  ];
  const total = data.reduce((s, d) => s + d.value, 0);
  return (
    <div className="panel p-6 sm:p-8" data-testid="allocation-chart">
      <p className="eyebrow">Allocation</p>
      {total === 0 ? (
        <p className="mt-10 text-sm text-slate-500">Your allocation appears here once you fund your account.</p>
      ) : (
        <>
          <div className="h-48">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={data} dataKey="value" innerRadius={55} outerRadius={80} paddingAngle={3} stroke="none">
                  {data.map((d, i) => <Cell key={d.name} fill={COLORS[i]} />)}
                </Pie>
                <Tooltip formatter={(v) => money(v)} contentStyle={{ background: "#121824", border: "1px solid #1E293B", borderRadius: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            {data.map((d, i) => (
              <li key={d.name} className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-slate-400"><span className="h-2 w-2 rounded-full" style={{ background: COLORS[i] }} />{d.name}</span>
                <span className="font-mono text-slate-200">{((d.value / total) * 100).toFixed(1)}%</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
